import type { LayerKey } from '@festina-life/api'
import { paperStyles } from '@festina-life/ui/libs'
import { Icon, Typography } from '@festina-life/ui/structure'
import cx from 'classnames'

import { useTranslateLayer } from '../../hooks/useTranslateLayer'

type Props = {
  layer: LayerKey
  isSecondaryBackground?: boolean
  shouldShowIcon?: boolean
  className?: string
}

export const LayerIndicator = ({
  layer,
  isSecondaryBackground,
  shouldShowIcon,
  className,
}: Props) => {
  const translateLayer = useTranslateLayer()
  return layer.layerId || layer.tenantId ? (
    <Typography
      size="sm"
      intensity="secondary"
      weight="semibold"
      className={cx(
        'm-0 rounded-md px-1! shadow-md flex items-center gap-x-1',
        paperStyles({ isFaded: !isSecondaryBackground }),
        className,
      )}
    >
      {shouldShowIcon && <Icon name="Square3Stack3D" />}
      {translateLayer(layer)}
    </Typography>
  ) : null
}
